import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import RouteScrollReset from './component/RouteScrollReset';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import store from './redux/store';
import { ToastContainer } from 'react-toastify';
import { AppContext, socket } from './context/context';
import { PhotoProvider } from 'react-photo-view';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PhotoProvider>
      <Provider store={store}>
        <AppContext.Provider
          value={{
            socket,
          }}
        >
          <BrowserRouter>
            <RouteScrollReset />
            <App />

            <ToastContainer />
          </BrowserRouter>
        </AppContext.Provider>
      </Provider>
    </PhotoProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
